import { Stack } from '@mui/material';

import { ErrorBoundary } from '../ErrorBoundry.tsx';
import { TrialAppRoutes } from './TrialAppRoutes.tsx';

export function TrialAppContent() {
  return (
    <Stack component="main" height="100vh" width="100%" sx={{ overflow: 'auto' }}>
      <ErrorBoundary>
        <TrialAppRoutes />
      </ErrorBoundary>
    </Stack>
  );
}
